var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.sent)?_c('b-button',{attrs:{"variant":"outline-primary","id":'report-button-' + _vm.reportId},on:{"click":_vm.send}},[(_vm.sending)?_c('b-spinner',{staticClass:"status_spinner",attrs:{"small":"","label":"Spinning"}}):[_c('font-awesome-icon',{attrs:{"icon":['fas', 'paper-plane']}}),_vm._v("\n        Send\n    ")]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }